<template>
    <div class="mainRow">
        <van-row>
            <van-col span="8" class="alignData">
                <img src="@/assets/themeFour/f1.png" alt="" width="45%">
                <img src="@/assets/themeFour/f2.png" alt="" width="20%">
            </van-col>
            <van-col span="16" class="container">
                <div v-for="(item, index) in mediaList" :key="index" style="margin:5px;">
                    <img :src="item.url" alt="" v-if="item.display" @click="goToShare(item.redirectUrl)">
                </div>
            </van-col>
        </van-row>
    </div>
</template>

<script setup lang="ts">
import { goToShare, MediaItem } from '@/view/home/supportScript';
import { ref, onMounted } from 'vue';

const props = defineProps<{
    itemData: {
        shareMediaList: MediaItem[]
    }
}>()
const mediaList = ref(props.itemData.shareMediaList)

onMounted(() => {
    mediaList.value = props.itemData.shareMediaList
})
</script>
<style scoped>
.container {
    display: flex;
    justify-content: right;
    padding: 8px 10px;
    border-radius: 9px;
}

.mainRow {
    background: rgb(0, 86, 85);
    border-bottom: 0.0625rem solid transparent;
    border-image: linear-gradient(to right, rgb(114, 57, 7), rgb(251, 242, 107), rgb(114, 57, 7)) 1;
}
.alignData{
    display: flex;
    align-items: center;
}
.container img {
    width: 35px;
    height: 35px;
}
</style>